import type { FixedNumber } from "@ethersproject/bignumber";
import type { Address } from "viem";
import { AddressZero } from "@/lib/constants";
import dictionaryConfig from "@/../config/dictionary.config";

export const isEmptyAmount = (amount?: number | null): boolean => {
  return amount === null || amount === undefined || amount == dictionaryConfig.statsDefaultValue;
};

/**
 * Utility function to check if the token is native for the balance's chain
 *
 * @param {{address: string | Address}} balance
 * @return {boolean}
 */
export function isNativeToken(balance: { address: string | Address }): boolean {
  return ["0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", AddressZero.toLowerCase()].includes(balance.address.toLowerCase());
}

/**
 *
 * @param {FixedNumber} value
 * @returns {string}
 */
export function cutFractionalPartFromAmount(value: FixedNumber | string) {
  return value.toString().replace(/(\d+)\.(\d+)/g, "$1");
}
